// extracted by mini-css-extract-plugin
module.exports = {"w4ln40i":"w4ln40i","s15za2df":"s15za2df","s1qsi09f":"s1qsi09f","shimmer":"shimmer","slgln6u":"slgln6u"};